var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.isAuthenticated && _vm.appReady)?_c('div',{staticClass:"main"},[_c('header-app',{attrs:{"user":_vm.user}}),_c('router-view')],1):_c('loader-spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }